export default __webpack_public_path__ + "static/media/icons8-services.e88a02fc.svg";